/**
 * HTTP 请求基类
 */
import { CacheType, getCache, removeCache, setCache } from './cache'
import { request as baseRequest } from './base'
import * as httpConfig from '../config/http.config'
import {
  requrstShowLoadingTimer,
  setRequrstShowLoadingTimer,
  requrstShowLoadingCount,
  setRequrstShowLoadingCount,
  requrstShowErrorState,
  setRequrstShowErrorState
} from '../context/http'
import { showLoading, hideLoading } from '../pageApi/tip'
import { parse, stringify } from 'qs'
import { convertInitialToUppercase } from './object'

export default class Http {
  /**请求名称 默认''*/
  name

  /**方法名 默认''*/
  key

  /**请求头 默认{}*/
  header

  host

  /**完整的网络请求地址 默认'' */
  url

  /**请求类型 默认'POST'*/
  method

  responseType

  /**显示加载图 默认true*/
  showLoading = false

  /**加载中的提示语 */
  showLoadingTitle

  /**超时时间 */
  timeout

  /**参数 默认{}*/
  params = {}

  /** */
  data

  /**携带cookie */
  cookie = false

  /**请求数据放在queryString中 */
  queryStringData

  /**是否缓存 默认true*/
  isCache = true

  /**缓存用户 */
  cacheUserStr = ''

  /**缓存key附加值 */
  cacheKeyAddData

  /**缓存Id */
  get cacheId() {
    const id = this.cacheUserStr + this.url + (this.params ? JSON.stringify(this.params) : '') + (this.data ? JSON.stringify(this.data) : '')
    return id
  }

  /**缓存时间 秒 */
  cacheTime = 10

  /**缓存时间 时间戳 */
  get cacheTimed() {
    return Date.parse(new Date()) + (this.cacheTime || 60) * 1000
  }

  /**缓存类型 */
  cacheType = CacheType.http

  /**验证登录状态 默认true */
  checkLogin = true

  /**加载中透明蒙层，防止触摸穿透 */
  showloadMask = true

  /**重发次数 */
  reloadCount = 0

  /**异常提醒 */
  errorWarn = true

  /**校验重发次数 */
  checkReloadCount() {
    if (this.reloadCount >= 2) {
      //不超过两次
      console.log('reloadCount', this.reloadCount)
      return false
    }
    return true
  }

  /**解决服务器返回的已知异常 */
  async solveError(res) {
    return 'check-true'
  }

  /**重发请求 */
  async reload() {
    console.log('>>重发:' + this.name + ' ' + this.key + ' ' + this.method + ' ' + this.url)
    //this.clearHttpCache()
    this.reloadCount++
    return await this.request()
  }

  /**移除http缓存 */
  async clearHttpCache() {
    await removeCache(this.cacheId, this.cacheType == undefined ? CacheType.http : this.cacheType)
  }

  getCacheSet() {}

  /**wxp request 的请求对象 */
  _requestObj = {}

  /**
   * 创建请求对象
   */
  constructor(obj) {
    Object.assign(this, obj)
  }

  async request() {
    /**检测网络状态 无网络则提示并终止请求 */
    // let networkType = await getNetworkType()
    // if (networkType == 'none') {
    //   console.log('当前网络状态:' + networkType)
    //   return { Code: -999, Message: '当前网络不可用' }
    // }

    if (this.isCache) {
      const value = await getCache(this.cacheId, this.cacheType)

      if (value) {
        console.log('┍‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧ get cache')
        console.log(this.name + ' ' + this.key + ' ' + (this.url || ''))
        console.log('入参', this.data, this.params, '█▌ ' + JSON.stringify(this.data))
        console.log('出参', { data: convertInitialToUppercase(value?.data), _res: value })
        console.log('┕‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧‧')
        return [undefined, { data: value }]
      }
    } else {
      removeCache(this.cacheId, this.cacheType)
    }

    if (this.showLoading) {
      //清除上一个定时器
      if (requrstShowLoadingTimer) {
        clearTimeout(requrstShowLoadingTimer)
        console.log('clearTimeout', requrstShowLoadingTimer)
        setRequrstShowLoadingTimer(0)
      }
      //第一个加载，弹窗提示
      if (requrstShowLoadingCount === -1) {
        setRequrstShowLoadingCount(0)
        showLoading({
          title: this.showLoadingTitle || '加载中..',
          mask: this.showloadMask == undefined || this.showloadMask
        })
        console.log('showLoading')
      }
      setRequrstShowLoadingCount(requrstShowLoadingCount + 1)
      //console.log('LoadingCount++', requrstShowLoadingCount)
    }

    //发起请求
    const res = await baseRequest(
      {
        method: this.method,
        url: this.url,
        params: this.params,
        data: this.data,
        header: this.header,
        timeout: this.timeout,
        responseType: this.responseType
      },
      this._requestObj
    )
      .then(async (res) => {
        return [null, res]
      })
      .catch(async (err) => {
        return [err, null] //返回异常信息
      })

    //显示loading的请求数量降为0时隐藏loading
    if (this.showLoading) {
      setRequrstShowLoadingCount(requrstShowLoadingCount - 1)
      //console.log('LoadingCount--', requrstShowLoadingCount)

      if (requrstShowLoadingCount === 0) {
        setRequrstShowLoadingTimer(
          setTimeout(() => {
            if (requrstShowLoadingCount < 1) {
              hideLoading()
              setRequrstShowLoadingCount(requrstShowLoadingCount - 1)
              console.log('hideLoading')
            }
          }, 50)
        )
        //console.log('Loading Timer', requrstShowLoadingTimer)
      }
    }

    if (true) {
      console.log('┌──────────────')
      console.log(this._requestObj.id + ' ' + this.name + ' ' + this.key + ' ' + this.method + ' ' + this.url)
      console.log(
        '入参',
        { ...this.data, _params: this.params, _header: this.header, _signParams: this.signParams },
        '█▌ ' + JSON.stringify(this.data)
      )
      console.log('出参', { data: convertInitialToUppercase(res[1]?.data), _res: res[1] })
      console.log('└──────────────')
    }

    // if (res[0]) {
    //   //wx.request=>fail在这里处理
    //   if (this.errorWarn && !requrstShowErrorState) {
    //     setRequrstShowErrorState(true)
    //     showModal({
    //       icon: 'error',
    //       title: '网络错误',
    //       content: '请求数据失败,请重试',
    //       onOk() {
    //         setRequrstShowErrorState(false)
    //       }
    //     })
    //   }

    //   console.log('err--------', res[0])
    //   throw res[0]
    // }

    if (res[1]) {
      const resData = res[1].data //以下代码用到

      //解决已知异常
      /**已知错误处理 */
      const seRes = await this.solveError(resData)
      if (seRes === 'check-true') {
        //继续执行后面的代码
      } else if (seRes === 'check-false') {
        console.warn('check-false 返回值校验未通过')
        // return {Code:-999,Message:'请求异常'}
        throw res[0]
      } else if (seRes === 'check-false-continue') {
        console.warn('check-false-continue 返回值校验未通过') //继续执行后面的代码
      } else {
        return seRes //重发请求返回值
      }

      if (this.isCache && resData && resData.Code == 0) {
        await setCache({
          id: this.cacheId,
          type: this.cacheType,
          value: resData,
          timed: this.cacheTimed
        })
      }
    }

    return res
  }
}
